import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from 'sweetalert2';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import PrimaryTable from '../helpers/primary-table'
import ReactLoading from 'react-loading';
import { catchError } from '../helpers/catch-error'




const WorkOrderSearch = () => {
    const navigate = useNavigate();
    const [workOrderSearch, setWorkOrderSearch] = useState(false);
    const [workOrders, setWorkOrders] = React.useState(null);
    const [isLoading, setIsLoading] = useState(false);

    var columns = React.useMemo(
        () => [
            {
                accessorFn: row => <a href={"/client/work-order/" + row.work_order_id} className="btn btn-link" >{row.work_order_no}</a>,
                id: "work_order_id",
                cell: info => info.getValue(),
                header: () => "Order #",
            },
            {
                accessorFn: row => row.patient_last_name + " " + row.patient_first_name,
                id: "lastName",
                cell: info => info.getValue(),
                header: () => "Patient",
                footer: props => props.column.id
            },
            {
                accessorKey: "facility_name",
                header: "Facility",
                footer: props => props.column.id
            },
            {
                accessorKey: "client_company_name",
                header: "Client",
                footer: props => props.column.id
            }
        ],
        []
    )



    const searchWorkOrders = () => {

        setIsLoading(true);

        var search_elements = {}

        search_elements.work_order_id = workOrderSearch?.work_order_id;
        search_elements.follow_up_date = workOrderSearch?.follow_up_date;
        search_elements.patient_first_name = workOrderSearch?.patient_first_name;
        search_elements.patient_middle_name = workOrderSearch?.patient_middle_name;
        search_elements.patient_last_name = workOrderSearch?.patient_last_name;
        search_elements.patient_dob = workOrderSearch?.patient_dob;
        search_elements.patient_ssn = workOrderSearch?.patient_ssn;
        search_elements.patient_med_rec_num = workOrderSearch?.patient_med_rec_num;
        search_elements.client_company_name = workOrderSearch?.client_company_name;
        search_elements.facility_name = workOrderSearch?.facility_name;
        search_elements.wo_policy_number = workOrderSearch?.wo_policy_number;
        search_elements.work_order_no = workOrderSearch?.work_order_no;
        search_elements.global_search = workOrderSearch?.global_search;

        axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/client/search-work-orders", search_elements, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        }).then(function (response) {

            if (response?.data?.status) {

                setWorkOrders(response?.data?.work_orders);

            }
            else {

                setWorkOrders(null);

            }
            setIsLoading(false);


        }).catch(function (error) {

            setIsLoading(false);
            catchError(error, navigate)

        });


    }


    return (
        <>


            <div className="card card-form card-primary mt-4 pb-2">
                <div className="card-heading px-5 py-3"><h6 className="fw-bold my-0">SEARCH WORK ORDERS</h6></div>
                <div className="card-body px-5">
                    <form className="form-horizontal form-thick mb-2"  >

                        <div className="row  gx-2 py-3">
                            <div className="col-12 my-2">
                                <div className="input-group">

                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Quick search: Patient, Facility, Client, MR#, Case #, Work Order..."
                                        value={workOrderSearch?.global_search || ""}
                                        onChange={(e) =>
                                            setWorkOrderSearch({
                                                ...workOrderSearch,
                                                global_search: e.target.value
                                            })
                                        }
                                        onKeyDown={(e) => {
                                            if (e.key === "Enter") {
                                                e.preventDefault();
                                                searchWorkOrders();
                                            }
                                        }}
                                    />

                                    <button
                                        className="btn btn-primary"
                                        type="button"
                                        onClick={searchWorkOrders}
                                    >
                                        Search
                                    </button>

                                    <button
                                        className="btn btn-secondary"
                                        type="button"
                                        onClick={() =>
                                            setWorkOrderSearch({
                                                ...workOrderSearch,
                                                global_search: ""
                                            })
                                        }
                                    >
                                        Reset
                                    </button>

                                </div>
                            </div>
                        </div>

                        <div className="row  gx-2">

                            <div className="col-xl-3  col-lg-3 col-sm-12 my-1">
                                <label htmlFor="work_order_id" >WORK ORDER ID</label>
                                <input name="work_order_id" className="form-control" type="text"
                                    value={workOrderSearch?.work_order_id}
                                    onChange={(e) =>
                                        setWorkOrderSearch({ ...workOrderSearch, work_order_id: e.target.value })
                                    }
                                />
                            </div>
                            <div className="col-xl-3  col-lg-3 col-sm-12 my-1">
                                <label htmlFor="work_order_no" >WORK ORDER #</label>
                                <input name="work_order_no" className="form-control" type="text"
                                    value={workOrderSearch?.work_order_no}
                                    onChange={(e) =>
                                        setWorkOrderSearch({ ...workOrderSearch, work_order_no: e.target.value })
                                    }
                                />
                            </div>
                            <div className="col-xl-3  col-lg-3 col-sm-12 my-1">
                                <label htmlFor="follow_up_date" >FOLLOW UP DATE</label>

                                <DatePicker name="follow_up_date" id="follow_up_date" type="text"
                                    className="form-control" placeholder="e.g. MM/DD/YYYY" showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    selected={workOrderSearch?.follow_up_date}
                                    onChange={(e) => {
                                        var dt = new Date(e);

                                        const year = dt.getFullYear();
                                        const month = (dt.getMonth() + 1).toString().padStart(2, "0");
                                        const day = dt.getDate().toString().padStart(2, "0");

                                        const formatted_date = month + '/' + day + '/' + year
                                        setWorkOrderSearch({ ...workOrderSearch, follow_up_date: formatted_date })

                                    }
                                    }
                                />

                            </div>
                            <div className="col-xl-3  col-lg-3 col-sm-12 my-1">
                                <label htmlFor="patient_first_name" >First Name</label>
                                <input name="patient_first_name" className="form-control" type="text"
                                    value={workOrderSearch?.patient_first_name}
                                    onChange={(e) =>
                                        setWorkOrderSearch({ ...workOrderSearch, patient_first_name: e.target.value })
                                    }
                                />
                            </div>
                            <div className="col-xl-3  col-lg-3 col-sm-12 my-1">
                                <label htmlFor="patient_middle_name">Middle Name</label>
                                <input name="patient_middle_name" className="form-control" type="text"
                                    value={workOrderSearch?.patient_middle_name}
                                    onChange={(e) =>
                                        setWorkOrderSearch({ ...workOrderSearch, patient_middle_name: e.target.value })
                                    }
                                />
                            </div>
                            <div className="col-xl-3  col-lg-3 col-sm-12 my-1">
                                <label htmlFor="patient_last_name">Last Name</label>
                                <input name="patient_last_name" className="form-control" type="text"
                                    value={workOrderSearch?.patient_last_name}
                                    onChange={(e) =>
                                        setWorkOrderSearch({ ...workOrderSearch, patient_last_name: e.target.value })
                                    }
                                />

                            </div>

                            <div className="col-xl-3  col-lg-3 col-sm-12 my-1">
                                <label htmlFor="patient_dob">Date of Birth</label>
                                <DatePicker name="patient_dob" id="patient_dob" type="text"
                                    className="form-control" placeholder="MM/DD/YYYY" showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    selected={workOrderSearch?.patient_dob}
                                    onChange={(e) => {
                                        var dt = new Date(e);

                                        const year = dt.getFullYear();
                                        const month = (dt.getMonth() + 1).toString().padStart(2, "0");
                                        const day = dt.getDate().toString().padStart(2, "0");

                                        const formatted_date = month + '/' + day + '/' + year

                                        setWorkOrderSearch({ ...workOrderSearch, patient_dob: formatted_date })

                                    }

                                    }
                                />

                            </div>
                            <div className="col-xl-3  col-lg-3 col-sm-12 my-1">
                                <label htmlFor="patient_ssn">SSN</label>
                                <input name="patient_ssn" id="patient_ssn" type="text" className="form-control"
                                    value={workOrderSearch?.patient_ssn} placeholder="000-00-0000"
                                    onChange={(e) =>
                                        setWorkOrderSearch({ ...workOrderSearch, patient_ssn: e.target.value })
                                    }

                                />

                            </div>
                            <div className="col-xl-3  col-lg-3 col-sm-12 my-1">
                                <label htmlFor="patient_med_rec_num">Medical Record #</label>
                                <input name="patient_med_rec_num" id="patient_med_rec_num" type="text" className="form-control"
                                    value={workOrderSearch?.patient_med_rec_num}
                                    onChange={(e) =>
                                        setWorkOrderSearch({ ...workOrderSearch, patient_med_rec_num: e.target.value })
                                    }

                                />

                            </div>

                            <div className="col-xl-3  col-lg-3 col-sm-12 my-1">
                                <label htmlFor="client_company_name">Client/Company Name</label>
                                <input name="client_company_name" id="client_company_name" type="text" className="form-control"
                                    value={workOrderSearch?.client_company_name} onChange={(e) =>
                                        setWorkOrderSearch({ ...workOrderSearch, client_company_name: e.target.value })
                                    }
                                />

                            </div>
                            <div className="col-xl-3  col-lg-3 col-sm-12 my-1">
                                <label htmlFor="facility_name">Facility Name</label>
                                <input name="facility_name" id="facility_name" type="text" className="form-control"
                                    value={workOrderSearch?.facility_name} onChange={(e) =>
                                        setWorkOrderSearch({ ...workOrderSearch, facility_name: e.target.value })
                                    }
                                />

                            </div>
                            <div className="col-xl-3  col-lg-3 col-sm-12 my-1">
                                <label htmlFor="wo_policy_number">Claim/Policy Number</label>
                                <input name="wo_policy_number" id="wo_policy_number" type="text" className="form-control"
                                    value={workOrderSearch?.wo_policy_number} onChange={(e) =>
                                        setWorkOrderSearch({ ...workOrderSearch, wo_policy_number: e.target.value })
                                    }

                                />

                            </div>


                        </div>


                    </form>

                </div>

                <div className="card-footer">
                    <div className="row">
                        <div className="col-xl-12 col-lg-12 col-sm-12 text-center">
                            <button onClick={() => searchWorkOrders()} className="btn btn-success mx-1" type="button" disabled={isLoading ? true : false} >{isLoading ? <><div className="spinner-border spinner-border-sm me-1" role="status"></div><span className="sr-only">Loading...</span></> : "SEARCH"} </button>
                            <button onClick={() => { setWorkOrders(null) }} className="btn btn-warning mx-1" type="button">CLEAR SEARCH </button>
                        </div>

                    </div>
                </div>
            </div>




            {(workOrders || isLoading) &&

                <div className="card card-form card-primary mt-3 " >
                    <div className="card-body p-0 mb-0" >

                        {isLoading ?
                            <div className="loader">
                                <ReactLoading type={"cylon"} color={"#E4F0FD"} height={250} width={250} />
                            </div>
                            :
                            <PrimaryTable columns={columns} data={workOrders} />
                        }


                    </div>
                </div>

            }


        </>


    );
};

export default WorkOrderSearch;